import { render, staticRenderFns } from "./ZoneConIndividualAwardCreate.vue?vue&type=template&id=534cda9f"
import script from "./ZoneConIndividualAwardCreate.vue?vue&type=script&lang=js"
export * from "./ZoneConIndividualAwardCreate.vue?vue&type=script&lang=js"
import style0 from "./ZoneConIndividualAwardCreate.vue?vue&type=style&index=0&id=534cda9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports